import Vue from 'vue';
import Vuex from 'vuex';

import account from './account';
import application from './application';
import card from './card';
import institution from './institution';
import property from './property';
import airQuality from './airquality';
import notification from './notification';
import content from './content';

Vue.use(Vuex);

export default async function () {
  return new Vuex.Store({
    modules: {
      account,
      application,
      card,
      institution,
      property,
      airQuality,
      notification,
      content,
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEV,
  });
}
